import PaystackPop from "@paystack/inline-js"

export type PaystackCheckoutPayload = {
  accessCode?: string
  url?: string
  reference?: string
  paystackReference?: string
}

export type PaystackCheckoutCallbacks = {
  onStarted?: (reference?: string) => void
  onSuccess?: (reference: string) => void
  onCancel?: () => void
  onError?: (message: string) => void
}

export function openPaystackCheckout(
  payload: PaystackCheckoutPayload,
  callbacks: PaystackCheckoutCallbacks = {}
): boolean {
  const reference = payload.paystackReference ?? payload.reference

  if (payload.accessCode) {
    const popup = new PaystackPop()
    callbacks.onStarted?.(reference)
    popup.resumeTransaction(payload.accessCode, {
      onSuccess: (transaction: { reference: string }) => {
        callbacks.onSuccess?.(transaction.reference)
      },
      onCancel: () => {
        callbacks.onCancel?.()
      },
      onError: (error: { message: string }) => {
        callbacks.onError?.(error.message)
      },
    })
    return true
  }

  if (payload.url) {
    window.open(payload.url, "_blank")
    callbacks.onStarted?.(reference)
    return true
  }

  return false
}
